
class TerraService {
	constructor() {
		this.apiUrl = process.env.TBX_API_TERRA || (window.AppENV && window.AppENV.TBX_API_TERRA);
	}

  getMsisdnAndPin = async (token, data) => {
		let loadJSONP = function () {
			let unique = 0;
			return function (url, callback, context) {
				// INIT
				let src;
				unique = unique + 1;
				const name = `_jsonp_${unique}`;
				let script = document.createElement('script');

				if (url.match(/\?/)) src = `${url}&callback=${name}`;
				else src = `${url}?callback=${name}`;

				// Create script
				script.type = 'text/javascript';
				script.src = src;

				// Setup handler
				window[name] = function (resolveData) {
					callback.call((context || window), resolveData);
					document.getElementsByTagName('head')[0].removeChild(script);
					script = null;
					delete window[name];
				};

				// Load JSON
				document.getElementsByTagName('head')[0].appendChild(script);
			};
		};
		loadJSONP = loadJSONP();
		const url = `${this.apiUrl}/Detect.asmx/BrVivoWho?data=${data}&ttkn=${token}`;
		const [response] = (await new Promise((resolve) => loadJSONP(url, resolve))).RESPONSE;

		if (response.STATUS === 'OK') {
			return ({
				ok: true,
				msisdn: response.E1,
				pin: response.E2
			});
		}
		return ({ok: false});
  }
}

export default new TerraService();



// WEBPACK FOOTER //
// ./src/services/TerraService.js